<template>
  <modal :id="itemStatusModalId">
    <div class="add-user">
      <b-row>
        <b-col>
          <close-button
            class="float-right"
            @close-button-click="handleCloseBtnClick"
          />
        </b-col>
      </b-row>
      <h3>Add Blog Post</h3>
      <b-row>
        <b-col v-if="false">
          <b-img
            v-if="formBblog && formBblog.imgURL"
            :src="formBblog.imgURL"
            fluid
            style="object-fit: contain"
            :alt="`My Memory with Derriana`"
          />
          <image-upload
            v-else
            ref="image-upload"
            class="photo-upload-wrapper"
            :img-upload-idx="idx"
            img-upload-type="photo"
            :storage-path="storagePath"
            :max-image="1"
            :show-edit="false"
            :show-delete="true"
            text-drag="Click to upload or drag photo memory (.png, .jpg) here. "
            @img-uploaded-url="handlePhotoUploadedURL"
          />
        </b-col>
        <b-col>
          <!-- NAME -->
          <b-form-group>
            <label-info
              v-if="false"
              id="form-title"
              label-name="Blog Title"
              label-info=""
            />
            <b-form-input
              v-model="formBblog.title"
              type="text"
              class="custom-input"
              style="
                    border-radius:50px;
                    padding:20px;"
              placeholder="Blog Title"
            />
          </b-form-group>
          <!-- URL -->
          <b-form-group>
            <label-info
              id="form-name"
              label-name="Your Name"
              label-info=""
            />
            <b-form-input
              v-model="formBblog.name"
              type="text"
              class="custom-input"
              style="
                    border-radius:50px;
                    padding:20px;"
              placeholder="Your Name"
            />
          </b-form-group>
          <!-- DESCRIPTION (OPT)-->
          <b-form-group
            id="input-group-1"
            label="Post:"
            label-for="input-description"
            style="margin-top: 25px;"
            description="Copy and Paste"
          >
            <transition name="fadeHeight" mode="out-in">
              <editor
                id="textarea-default"
                v-show="formBblog"
                @input="input"
                :clear="clear"
                :content="formBblog.description"
                @resetClear="resetClear"
              />
            </transition>
          </b-form-group>
          <span class="error">
            <div v-for="(anError, i) in this.errors" :key="`err_${i}`">
              {{ anError }}
            </div>
          </span>
          <b-form-group>
            <b-button
              v-if="this.bblogData && this.isUpdate"
              pill
              class="btn btn-success float-right"
              style="border: none; background-color: #fe818b; padding: 10px;"
              @click="handleUpdateBblogClick"
            >
              Update
              {{ formBblog && formBblog.title ? formBblog.title : "your Bblog" }}
            </b-button>
            <b-button
              v-else
              pill
              class="btn btn-success float-right"
              style="border: none; background-color: #fe818b; padding: 10px;"
              @click="handleAddBblogClick"
            >
              Add {{ formBblog && formBblog.title ? formBblog.title : "your Bblog" }}
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/common/modal";
import CloseButton from "@/components/common/closeButton";
import UploadImage from "@/mixins/UploadImage";
import VideoHandling from "@/mixins/VideoHandling";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";
import axios from "axios";
export default {
  name: "Admin_Manage_AddEditItem_Blogs",
  mixins: [UploadImage, VideoHandling],
  components: {
    Modal,
    CloseButton,
    ImageUpload,
    Editor
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    itemStatusModalId: {
      type: String,
      default: "add-edit-item-status"
    }
  },
  computed: {
    formData() {
      return this.entity && this.entity.form ? this.entity.form : null;
    }
  },
  created() {
    this.formReset();
  },
  mounted() {},
  methods: {
    handleAddItem() {
      this.isUpdate = false;
      this.$bvModal.show(this.itemStatusModalId);
    },
    handleUpdateItem(bblogData) {
      this.isUpdate = true;
      this.bblogData = bblogData;
      this.formBblog = bblogData && bblogData.form ? _.clone(bblogData.form) : {};
      this.$bvModal.show(this.itemStatusModalId);
    },
    handleCloseBtnClick() {
      this.entity = null;
      this.$bvModal.hide(this.itemStatusModalId);
    },
    handlePhotoUploadedURL(idx, url) {
      this.formBblog.imgURL = url;
    },
    handleAddBblogClick() {
      if (this.simpleValidate().length > 0) return;

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("user/submitBblog", {
            form: this.formBblog,
            ip
          })
          .then(res => {
            this.$emit("item-added");
            this.handleCloseBtnClick();
            this.formReset();
          });
      });
    },
    handleUpdateBblogClick() {
      debugger;
      if (this.simpleValidate().length > 0) return;

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("user/updateBblog", {
            id: this.bblogData && this.bblogData.id ? this.bblogData.id : null,
            form: this.formBblog,
            ip
          })
          .then(res => {
            this.$emit("item-added");
            this.handleCloseBtnClick();
            this.formReset();
          });
      });
    },
    simpleValidate() {
      this.errors = [];

      /* if (this.formBblog && !this.validateEmail(this.formBblog.email))
         this.errors.push("Please enter a valid email");*/

      if (
        (this.formBblog && !this.formBblog.title) ||
        this.formBblog.title.length === 0
      )
        this.errors.push("Please enter blog title");

      if (
        (this.formBblog && !this.formBblog.name) ||
        this.formBblog.name.length === 0
      )
        this.errors.push("Your Name  is required");

      return this.errors;
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    formReset() {
      this.formBblog = null;
      this.formBblog = this.formDefault;
    },
    handleSubmitANewMemory() {
      this.formReset();
      this.memorySubmitted = false;
    },
    input(val) {
      this.formBblog.description = val.content;
    },
    resetClear() {
      this.clear = false;
    }
  },
  data() {
    return {
      clear: false,
      idx: 0,
      storagePath: "derriana_bblogs_imgs",
      isUpdate: false,
      bblogData: null,
      formBblog: null,
      formDefault: {
        title: null,
        description: [],
        name: null,
        imgURL: null
      },
      errors: [],
      entity: null
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>
